import { useQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { getNotifySubscriptionGroupsPublic } from "../../../queries/notify";

export function useNotifySubscriptionGroupsPublic() {
  const networkHeaders = useNetworkHeaders();
  const { data: publicSubscriptionGroups, isLoading: isPublicSubscriptionGroupsLoading } = useQuery(
    buildNotifySubscriptionGroupsPublicQueryKey(),
    getNotifySubscriptionGroupsPublic(networkHeaders),
    {
      queryFnParamsFilter(args) {
        return [args[1]];
      },
      keepPreviousData: true,
    },
  );

  return { publicSubscriptionGroups, isPublicSubscriptionGroupsLoading };
}

export function buildNotifySubscriptionGroupsPublicQueryKey() {
  return "notifySubscriptionGroupsPublic";
}
